import { render, staticRenderFns } from "./MainSettings.vue?vue&type=template&id=7c2b0d8a&"
import script from "./MainSettings.vue?vue&type=script&lang=js&"
export * from "./MainSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports